<template>
    <div>
        <div v-if="shouldIncludeLayout == 'default'" class="container">
            <div :class="'background-color' + showIndexBg ? '' : 'background-color-o'"></div>
            <div v-if="showIndexBg" class="background-image animated zoomOut"></div>
            <div v-else class="background-image background-image-o"></div>
            <Header/>
            <div :style="showIndexBg ? '' : 'background-color: #fff'">
                <loading :loading="loading">
                    <router-view/>
                </loading>
            </div>
            <Footer/>
        </div>
        <div v-else-if="shouldIncludeLayout == 'payment'">
            <loading :loading="loading">
                <my-payment-record :menu="meta.payment && meta.payment.menu">
                    <router-view/>
                </my-payment-record>
            </loading>
        </div>
        <div v-else>
            <loading :loading="loading">
                <router-view/>
            </loading>
        </div>
        <div v-if="Object.keys(backTopStyles).includes(shouldIncludeLayout)" class="back-top" :style="backTopStyles[shouldIncludeLayout]">
            <a-back-top :visibilityHeight="200">
                <div class="back-top-box">
                    <svg t="1748426653278" class="icon batman" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5410"
                         width="35" height="35"><path d="M1023.978667 897.898667A126.08 126.08 0 0 1 897.898667 1024H126.08A126.08 126.08 0 0 1 0 897.898667V126.08A126.08 126.08 0 0 1 126.08 0h771.818667a126.08 126.08 0 0 1 126.08 126.08v771.818667z" fill="rgba(0,0,0,.45)" p-id="5411"></path><path d="M536.64 753.578667l-12.437333 4.586666v0.021334h-0.106667v-0.021334l-8.682667-3.584-158.144-41.877333 39.082667 203.712H651.946667l39.04-203.712z" fill="#E4CCB4" p-id="5412"></path><path d="M588.053333 805.162667h-127.829333l-26.922667 30.656 26.922667-12.672h127.829333l26.944 12.672z" p-id="5413"></path><path d="M718.613333 108.714667c-11.456 23.722667-51.669333 140.544-65.344 151.445333-39.466667-10.901333-86.464-18.346667-126.122666-19.093333v-0.149334c-0.96 0-2.005333 0.085333-3.008 0.085334s-2.048-0.085333-3.050667-0.085334v0.149334c-39.616 0.725333-86.634667 8.192-126.08 19.093333-13.717333-10.901333-53.866667-127.701333-65.365333-151.445333-17.088-35.392-59.093333 472.192-59.008 475.776 0.298667 19.882667 33.621333 118.869333 34.325333 120.149333l91.370667 211.797333-39.082667-203.712 166.677333 44.117334h0.426667l166.634667-44.117334-39.04 203.712 91.328-211.797333c0.704-1.28 34.048-100.266667 34.368-120.149333 0.042667-3.605333-41.92-511.168-59.029334-475.776z" p-id="5414"></path><path d="M594.517333 647.552s60.8-59.157333 94.592-69.738667c33.749333-10.581333 13.461333 42.282667-11.413333 50.154667-24.832 7.850667-83.178667 19.584-83.178667 19.584zM453.738667 647.552s-60.757333-59.157333-94.549334-69.738667c-33.749333-10.581333-13.461333 42.282667 11.413334 50.154667 24.832 7.850667 83.136 19.584 83.136 19.584z" fill="#FFFFFF" p-id="5415"></path></svg>
                    <svg t="1748427049381" class="icon batman-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5904"
                         width="35" height="35"><path d="M454.207 147.571l11.554 59.784h92.478l11.554-59.784c11.554 39.856 34.686 126.776 34.686 155.466 42.38-3.98 124.834-33.496 115.586-119.59 0-11.967-9.272-40.682-46.24-59.808C777.833 147.57 988.204 262.38 997.452 530.302c-69.347-43.861-212.677-76.556-231.172 143.523-42.38-71.774-141-177.02-196.487-23.932C550.521 717.662 512 872.35 512 948.907c0-76.556-38.52-231.245-57.793-299.014-55.487-153.088-154.131-47.817-196.487 23.932-18.495-220.08-161.825-187.384-231.172-143.523 9.248-267.921 219.619-382.73 323.627-406.663-36.968 19.126-46.24 47.84-46.24 59.807-9.223 86.12 73.206 115.61 115.586 119.591 0-28.69 23.132-115.61 34.686-155.466z" p-id="5905" fill="#2c2c2c"></path></svg>
                </div>
            </a-back-top>
        </div>
        <search-modal ref="search_open"></search-modal>
    </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import MyPaymentRecord from "./components/MyPaymentRecord.vue";
import SearchModal from "@/view/components/SearchModal/index.vue";
export default {
    name: "index",
    components: {SearchModal, MyPaymentRecord, Header, Footer},
    provide() {
        return {
            setLoading: this.setLoading,
            openSearch: this.openSearch
        }
    },
    data() {
        return {
            loading: false,
            showIndexBg: true,
            backTopStyles: {
                default: {
                    '--bottom': '50px',
                    '--right': '10%'
                },
                payment: {
                    '--bottom': '100px',
                    '--right': '10%'
                }
            }
        }
    },
    watch: {
        $route(to){
            this.showIndexBg = ['/', '/as'].includes(to.path)
        }
    },
    computed: {
        shouldIncludeLayout() {
            const route = this.$route;
            // 默认为true，如果设置为false则为单独页面
            return route.meta.includeLayout == undefined ? 'default' : route.meta.includeLayout;
        },
        meta() {
            return this.$route.meta
        }
    },
    methods: {
        setLoading(loading = false) {
            this.loading = loading
        },
        openSearch(tag) {
            this.$refs['search_open'].open(tag)
        }
    }
}
</script>

<style lang="less" scoped>
.container {
    .background-color {
        background: #333;
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: -999;
    }
    .background-color-o {
        background: #fff;
    }
    .background-image {
        position: fixed;
        width: 100%;
        height: 100%;
        background-image: url("~@/assets/image/home_bg_oean.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: bottom;
        transition: transform 1.5s,opacity 1s;
        transform: scale(1.05);
        opacity: 0;
        z-index: -998;
    }
    .background-image-o {
        opacity: 1;
    }
}

.back-top {
    .ant-back-top {
        bottom: var(--bottom);
        right: var(--right);
        z-index: 999999;
    }
    .back-top-box {
        background-color: transparent;
        height: 35px;
        width: 35px;
        line-height: 35px;
        text-align: center;
        font-size: 20px;
        font-weight: 700;
        transition: all 0.3s;
        box-shadow: rgb(0 0 0 / 5%) 2px 2px 20px;
        color: #fff;
        position: relative;
        .icon {
            position: absolute;
            top: 0;
            left: 0;
            transition: all .3s;
        }
        .batman {
            opacity: 1;
        }
        .batman-icon {
            opacity: 0;
        }
    }
    .back-top-box:hover {
        box-shadow: none;
        .batman {
            opacity: 0;
        }
        .batman-icon {
            opacity: 1;
        }
    }
}


@-webkit-keyframes zoomOut {
    from {
        opacity: 0;
        -webkit-transform: scale(1.05);
        transform: scale(1.05);
    }

    to {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}

@keyframes zoomOut {
    from {
        opacity: 0;
        -webkit-transform: scale(1.05);
        transform: scale(1.05);
    }

    to {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}

.zoomOut {
    -webkit-animation-name: zoomOut;
    animation-name: zoomOut;
}
</style>
